import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-brand-dark border-t border-brand-mint/10" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row items-center gap-8 bg-brand-card/50 p-8 rounded-2xl border border-brand-mint/20" data-id="element-75">
          <div className="flex-shrink-0" data-id="element-76">
            <div className="w-24 h-24 bg-brand-dark rounded-full flex items-center justify-center border-4 border-brand-mint/30 shadow-inner" data-id="element-77">
              <ShieldAlert className="w-12 h-12 text-brand-mint" data-id="element-78" />
            </div>
          </div>
          <div className="text-center md:text-left" data-id="element-79">
            <h3 className="text-2xl font-display text-brand-cream mb-3 uppercase tracking-wide" data-id="element-80">
              Garantía de Satisfacción de 7 Días
            </h3>
            <p className="text-brand-cream/80 leading-relaxed" data-id="element-81">
              Estamos tan seguros de que este material te va a ahorrar horas de
              trabajo y mejorar tus clases, que te damos 7 días de garantía. Si
              sentís que la guía no cumple con tus expectativas, te devolvemos
              el 100% de tu dinero sin hacer preguntas. El riesgo es todo
              nuestro.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}